import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import findKey from "lodash/findKey";
import get from "lodash/get";
import { setVisible } from "../reducers/Ui/Actions";
import { setLoadCode, loadConfiguration } from "../reducers/Configuration/Actions";
import LoadConfiguration from "../Components/LoadConfiguration";
import { identifiers } from "../core/Constants";

export const LoadConfigurationContainer = ({
  LoadConfigurationComponent,
  close,
  setLoadCode,
  loadConfiguration,
  itemIdentifier,
  ...props
}) => {
  const [errorMessage, setErrorMessage] = useState();
  const history = useHistory();
  const onLoadClick = useMemo(
    () => async () => {
      try {
        await loadConfiguration();
      } catch (e) {
        setErrorMessage(e.message);
      }
    },
    [loadConfiguration]
  );

  useEffect(() => {
    if (itemIdentifier) {
      const itemIdentifierKey = findKey(identifiers, (i) => i === itemIdentifier);
      if (!location.pathname.includes("/code:") && !location.pathname.includes(itemIdentifierKey)) {
        history.push({
          pathname: "identifier:" + identifiers[itemIdentifier],
          search: window.location.search,
        });
      }
    }
  }, [itemIdentifier]);

  // hide the message if the component is reopened or the user changed the code
  useEffect(() => setErrorMessage(""), [props.show, props.loadCode]);

  // hide the message if loading is in progress
  useEffect(() => {
    props.workInProgress && setErrorMessage("");
  }, [props.workInProgress]);

  return (
    <LoadConfigurationComponent
      {...props}
      onClose={() => {
        close();
      }}
      onCodeChange={setLoadCode}
      onLoadClick={onLoadClick}
      errorMessage={errorMessage}
    />
  );
};
LoadConfigurationContainer.propTypes = {
  LoadConfigurationComponent: PropTypes.elementType.isRequired,
  close: PropTypes.func.isRequired,
  setLoadCode: PropTypes.func.isRequired,
  loadConfiguration: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  loadCode: PropTypes.string.isRequired,
  workInProgress: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const { ui, Configuration } = state;
  return {
    Component: LoadConfigurationContainer,
    LoadConfigurationComponent: LoadConfiguration,
    show: !!ui.visibilityMap.loadConfiguration,
    workInProgress: !!ui.backgroundWorkMap.loadConfiguration,
    loadCode: Configuration.loadCode || "",
    itemIdentifier: get(Configuration, "configuration.item.identifier", null),
  };
};

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(setVisible("loadConfiguration", false)),
  setLoadCode: (code) => dispatch(setLoadCode(code)),
  loadConfiguration: () => dispatch(loadConfiguration()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadConfigurationContainer);
